import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { Modal, Button, Flex } from "src/elements";
import { useModals } from "src/components/Modals";
import { useLoaders } from "src/components/InlineLoader";
import { useApi } from "src/api";
import { RoutePostStoresUpdateProducts } from "@CommonApi/stores/update-products";
import { FileUploader } from "src/components/FileUploader/FileUploader";
import { updateStoreProductsModalDataAtom } from "./store/atoms";
import { ResponseGetMerchflows_merchflowId_Details } from "@CommonApi/merchflows/_merchflowId_/details";
import { useAsyncState } from "src/hooks/useAsyncState";

export const UpdateStoreProductsModal = () => {
  const [data, setData] = useAtom(updateStoreProductsModalDataAtom);
  const { closeModal } = useModals();
  const { postStoresUpdateProductsApi, getMerchflowDetailsApi } = useApi();
  const [details, setDetails] = useAsyncState<ResponseGetMerchflows_merchflowId_Details>();
  const [file, setFile] = useState<File | null>(null);
  const { hasLoader } = useLoaders();
  const isUpdateLoading = hasLoader(RoutePostStoresUpdateProducts);

  useEffect(() => {
    if (data?.merchflowId) {
      getMerchflowDetailsApi(data.merchflowId).then(setDetails);
    }
  }, [data?.merchflowId]);

  useEffect(() => {
    return () => {
      setData(null);
    };
  }, []);

  if (!data) {
    return null;
  }

  const handleUpdate = async () => {
    if (!file || !data.data || !details?.category_id) return;

    const storeCodes = data.data.data.map((store) => store.store);

    const response = await postStoresUpdateProductsApi({
      file,
      storeCodes,
      categoryId: details.category_id,
    });

    if (response) {
      closeModal("UpdateStoreProductsModal");
    }
  };

  return (
    <Modal name="UpdateStoreProductsModal" title="Update Store Products" width="400px">
      <Flex padding="20px" column gap="20px">
        <FileUploader
          fileLabel="CSV file"
          fileType="csv"
          isLoading={isUpdateLoading}
          onChange={setFile}
        />

        <Flex justify="center">
          <Button isDisabled={!file || !details} isLoading={isUpdateLoading} onClick={handleUpdate}>
            Update Products
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
